

require('./styles');

require('xo-ui-components/src/directionality/directive');

define(['jquery', 'angular', 'squid/index', 'text!./template.html', '../lib/territoriesByCode', 'components/xo-ui-components/src/dropdown/directive', 'components/xo-ui-components/src/error-tooltip/directive', 'components/xo-ui-components/src/floating-label/directive'], function ($, angular, squid, template, countryPhoneCode) {

    angular.module('xo-phone.phoneInput', ['squid', 'xo-dropdown.directive', 'xo-error-tooltip.directive', 'floating-label.directive']).directive('xoPhoneInput', function () {
        return {
            template: template,
            scope: {
                phone: '=',
                showPhoneType: '=',
                exclude: '@'
            },

            link: function link(scope, element, attr, controller) {
                element.on('keyup', function (event) {
                    $('.telephone').mask(scope.mask, {
                        'translation': {
                            0: { pattern: /[0-9]/ }
                        }
                    });
                });
            },

            controller: function controller($scope, $feature, $locale) {
                $scope.locale = $locale;
                $scope.IntDialingCodes = countryPhoneCode;
                $scope.defaultCountryPhoneCode = countryPhoneCode[$locale.country];
                $scope.showPhoneType = $feature('phoneType', true, $scope.country) && $scope.showPhoneType !== false;

                // dont display countries that are tagged with hideInOtherCountries flag in territoriesByCode.js.
                // if localeCountry and dropdown country are same ignore hideInOtherCountries and display the countrycode.
                $scope.hideCountry = function (dropdownCountry, hideInOtherCountries) {
                    return $locale.country !== dropdownCountry && hideInOtherCountries;
                };

                $scope.phone = $scope.phone || {};
                $scope.phone.phoneType = $scope.phone.phoneType || 'Mobile';
                $scope.phone.IntDialingCountryCode = $scope.defaultCountryPhoneCode.phoneCountryCode;

                angular.extend($scope.phone, {
                    phoneCountryCode: $locale.country
                });

                function getPhoneMask(phoneType, phoneEntry) {
                    var defaultMask = '0000000000000000';
                    var masks = phoneEntry && phoneEntry.masks;
                    var mobileMask = masks && masks.MOBILE ? masks.MOBILE : defaultMask;
                    var fixedLineMask = masks && masks.FIXED_LINE ? masks.FIXED_LINE : defaultMask;
                    return phoneType === 'Mobile' ? mobileMask : fixedLineMask;
                }

                function getPhonePattern(phoneEntry) {
                    var defaultPattern = '^[0-9]+$';
                    var patterns = phoneEntry && phoneEntry.patterns;
                    // less stric regex validation in place for now, just use general regex to match mobile AND fixed-line formats
                    // for now we use less strict regex validation because we are not ready for this more strict validation
                    if (patterns) {
                        return patterns.GENERAL ? patterns.GENERAL : defaultPattern;
                    }
                    return defaultPattern;

                    // more strict regex validaiton based on phone type is found commented below
                    // var ret;
                    // switch ($scope.phone.phoneType) {
                    //     case 'Mobile':
                    //         ret = patterns.MOBILE;
                    //         break;
                    //     case 'Home':
                    //     case 'Work':
                    //         ret = patterns.FIXED_LINE;
                    //         break;
                    //     default:
                    //         ret = patterns.GENERAL;
                    //         break;
                    // }
                    // return ret ? ret : defaultPattern;
                }

                function populatePhoneMetadata() {
                    if (!$scope.metadata || $scope.metadata.country !== $locale.metadata.country) {
                        $scope.metadata = angular.copy($locale.metadata);
                    }
                    var phoneEntry = $scope.metadata.phoneEntry;
                    $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
                    $scope.pattern = getPhonePattern(phoneEntry);
                }

                populatePhoneMetadata();

                // Reset the phone number mask from according to the phone type
                $scope.phoneTypeChanged = function () {
                    $scope.mask = getPhoneMask($scope.phone.phoneType, $scope.metadata.phoneEntry);
                    $scope.pattern = getPhonePattern($scope.metadata.phoneEntry);
                    $('.telephone').mask($scope.mask);
                };

                $scope.$watch('phone.phoneCountryCode', function (newValue) {
                    $scope.phone.IntDialingCountryCode = countryPhoneCode[newValue].phoneCountryCode;
                });

                $scope.$on('localeChange', function () {
                    $scope.defaultCountryPhoneCode = countryPhoneCode[$locale.country];
                    $scope.phone.phoneCountryCode = $locale.country;
                    if (!$scope.metadata || $scope.metadata.country !== $locale.metadata.country) {
                        populatePhoneMetadata();
                        $('.telephone').mask($scope.mask);
                    }
                });

                $scope.showWork = $scope.exclude === 'WORK';
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/phone/phoneInput/directive.js
// module id = ./components/xo-form-components/src/phone/phoneInput/directive.js
// module chunks = 1